/* OB Tie Dye | guide discovery facets | 2026-10-25
   Non-destructive overlay. Filters the raw Shopify feed before recurrence expansion
   so List, Calendar, Map and pick modules use exactly the same data. */
(function(){
  'use strict';
  var root=document.getElementById('obg');
  if(!root || window.OB_GUIDE_FACETS_INIT) return;
  window.OB_GUIDE_FACETS_INIT=true;
  var url=new URL(window.location.href), params=url.searchParams;
  var genreOptions=[
    ['reggae','Reggae + Dub'],['jam','Jam + Psychedelic'],['funk','Funk + Soul'],
    ['electronic','Electronic + Dance'],['hiphop','Hip-Hop + Rap'],
    ['rock','Rock + Indie'],['punk','Punk + Ska'],['jazz','Jazz + Blues'],
    ['country','Country + Folk'],['pop','Pop + R&B'],['latin','Latin + World'],
    ['tribute','Grateful Dead + Tribute Bands'],['classical','Classical'],['other','Other / Unknown']
  ];
  var dayOptions=[['mon','Mon'],['tue','Tue'],['wed','Wed'],['thu','Thu'],['fri','Fri'],['sat','Sat'],['sun','Sun']];
  var typeOptions=[
    ['drinks','Drink specials'],['food','Food specials'],['games','Trivia + games'],
    ['music','Live music + karaoke'],['fitness','Fitness + outdoors'],['other','Other weekly']
  ];
  var optionMap={genre:genreOptions,hhday:dayOptions,hhtype:typeOptions};
  function pick(k){
    var allow=optionMap[k].map(function(p){return p[0]});
    return (params.get(k)||'').split(',').map(function(v){return v.trim().toLowerCase()})
      .filter(function(v,i,a){return allow.indexOf(v)!==-1 && a.indexOf(v)===i});
  }
  var selected={genre:pick('genre'),hhday:pick('hhday'),hhtype:pick('hhtype')};
  function contains(s,pat){return pat.test(s)}
  function genreKeys(e){
    var tags=String(Array.isArray(e.tags)?e.tags.join(' '):(e.tags||'')).toLowerCase();
    var title=String(e.title||'').toLowerCase();
    var desc=String(e.desc||'').toLowerCase();
    var s=tags+' '+title+' '+desc, out=[];
    function add(k,p){if(contains(s,p) && out.indexOf(k)<0)out.push(k)}
    add('reggae',/\b(reggae|reggae rock|dub|roots reggae|dancehall|rocksteady|island reggae|soca|bumpin uglies|common kings|rebelution|iration|slightly stoopid|the movement|kolohe kai|kbong|johnny cosmic|dirty heads|the elevators|matisyahu|ziggy marley|steel pulse|ub40)\b/i);
    add('jam',/\b(jam band|jamband|jamgrass|psychedelic|psych rock|grateful dead|deadhead|dead & company|phish|umphrey|papadosio|perpetual groove|disco biscuits|sts9|pigeons playing ping pong|goose tribute|the floozies)\b/i);
    add('funk',/\b(funk|funky|soul|motown|disco|groove|r&b|rhythm and blues|ne(al|il) francis|funk hunters|chali 2na|saxsquatch|break science)\b/i);
    add('electronic',/\b(electronic|edm|house music|deep house|techno|trance|dubstep|drum and bass|dnb|dj set|dance music|electro|bass music|rave|hardstyle|synthwave|future bass|flume|oakenfold|crystal method|fred again)\b/i);
    add('hiphop',/\b(hip[ -]?hop|rap|rapper|trap music|boom bap|emcee|mc\b|dj premier|talib kweli|chali 2na|wu[ -]?tang)\b/i);
    add('rock',/\b(rock|indie|alternative|alt rock|hard rock|metal|grunge|shoegaze|garage rock|yacht rock|prog rock|progressive rock|folk rock|classic rock|emo|guitar rock)\b/i);
    add('punk',/\b(punk|ska|hardcore|pop[ -]?punk|skacore|skate punk|sex pistols|bouncing souls|the interrupters|suicide machines|aggrolites)\b/i);
    add('jazz',/\b(jazz|blues|swing|big band|bebop|brass band|ragtime|jazz fusion|jazz quartet|blues jam)\b/i);
    add('country',/\b(country|bluegrass|americana|folk music|honky tonk|outlaw country|western swing|singer[ -]?songwriter|banjo|roots folk)\b/i);
    add('pop',/\b(pop music|indie pop|synth[ -]?pop|electropop|r&b|neo[ -]?soul|boy band|girl group|pop star|chart pop)\b/i);
    add('latin',/\b(latin|salsa|bachata|reggaeton|cumbia|mariachi|afrobeat|world music|bossa nova|brazilian|flamenco|k[ -]?pop|j[ -]?pop)\b/i);
    add('tribute',/\b(grateful dead|dead\s*(?:&|and)\s*(?:company|co\.?)(?=\b|\s)|deadheads?|dark star orchestra|joe russo['’]?s almost dead|jrad|grateful shred|grateful dub|jerry garcia|dead tribute|dead night|tribute|cover band|cover show|playing the music of)\b/i);
    if(contains(s.replace(/\bdark star orchestra\b/gi,''),/\b(classical|symphony|orchestra|chamber music|strings|candlelight concert|philharmonic|opera)\b/i))out.push('classical');
    return out.length?out:['other'];
  }
  function weekdayKeys(e){
    var days=String(e.days||'').toLowerCase(),out=[];
    if(/\b(daily|every day|all days|seven days|7 days)\b/.test(days))return dayOptions.map(function(x){return x[0]});
    if(/\b(weekdays|monday through friday|mon-fri|mon to fri)\b/.test(days))return ['mon','tue','wed','thu','fri'];
    if(/\b(weekends|weekend|saturday and sunday|sat-sun)\b/.test(days))return ['sat','sun'];
    var names={mon:/\b(mon|monday)\b/,tue:/\b(tue|tues|tuesday)\b/,wed:/\b(wed|weds|wednesday)\b/,thu:/\b(thu|thur|thurs|thursday)\b/,fri:/\b(fri|friday)\b/,sat:/\b(sat|saturday)\b/,sun:/\b(sun|sunday)\b/};
    dayOptions.forEach(function(o){if(names[o[0]].test(days))out.push(o[0])});
    if(!out.length && e.start_date){
      var m=String(e.start_date).match(/^(\d{4})-(\d{2})-(\d{2})/);
      if(m){var n=new Date(Date.UTC(+m[1],+m[2]-1,+m[3])).getUTCDay();out=[['sun','mon','tue','wed','thu','fri','sat'][n]]}
    }
    return out;
  }
  function typeKeys(e){
    var c=String(e.cat||'').toLowerCase(), s=(String(e.title||'')+' '+String(e.desc||'')+' '+(Array.isArray(e.tags)?e.tags.join(' '):e.tags||'')).toLowerCase(),out=[];
    function add(k,p){if(p.test(s)&&out.indexOf(k)<0)out.push(k)}
    add('drinks',/\b(drink|cocktail|beer|wine|margarita|whiskey|tequila|draft|pint|well drinks|spritz|bo(go|ttomless)|sangria|happy hour)\b/i);
    add('food',/\b(food|taco|pizza|burger|wing|sushi|oyster|appetizer|snack|dining|bites|nachos|ramen|fries|small plates|eat)\b/i);
    if(/trivia|bingo|game|poker|mahjong|quiz|board game|raffle/.test(c+' '+s))out.push('games');
    if(/concert|karaoke|dance|nightlife/.test(c) || /live music|open mic|karaoke|dj night|blues jam/.test(s))out.push('music');
    if(/fitness|outdoor/.test(c) || /run club|yoga|pilates|hike|walk club/.test(s))out.push('fitness');
    return out.length?out:['other'];
  }
  function isMusic(e){
    return /^(concert|music)$/i.test(String(e.cat||'')) ||
      /\b(live music|concert|music festival|reggae night|dj set|live band)\b/i.test((e.title||'')+' '+(Array.isArray(e.tags)?e.tags.join(' '):(e.tags||'')));
  }
  var raw=window.OB_GUIDE_RAW_FEED;
  if(Array.isArray(raw) && (selected.genre.length || selected.hhday.length || selected.hhtype.length)){
    window.OB_GUIDE_RAW_FEED=raw.filter(function(e){
      if(!e)return false;
      if(selected.genre.length && (!isMusic(e) || !selected.genre.some(function(k){return genreKeys(e).indexOf(k)!==-1})))return false;
      if(selected.hhday.length && !selected.hhday.some(function(k){return weekdayKeys(e).indexOf(k)!==-1}))return false;
      if(selected.hhtype.length && !selected.hhtype.some(function(k){return typeKeys(e).indexOf(k)!==-1}))return false;
      return true;
    });
  }
  var path=location.pathname.toLowerCase(),isWeekly=/happy-hours/.test(path),isGuide=/^\/pages\/events(?:-|$)/.test(path);
  var weeklyPages=['las-vegas','charlotte','minneapolis-st-paul','denver','honolulu','washington-dc','salt-lake-city','portland','phoenix','tokyo','tempe'];
  function weeklyLink(){
    var p=path.replace(/^\/pages\/events-?/,'').replace(/-happy-hours$/,'');
    return '/pages/events'+(weeklyPages.indexOf(p)>=0?'-'+p:'')+'-happy-hours';
  }
  function esc(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/"/g,'&quot;')}
  function build(){
    if(!isGuide || !root || document.getElementById('obgdFacets'))return;
    var anchor=root.querySelector('.obg-results-head') || root.querySelector('#obgList');
    if(!anchor){setTimeout(build,400);return;}
    var box=document.createElement('section');
    box.id='obgdFacets';box.className='obgd-facets';box.setAttribute('aria-label','Extra event filters');
    var music=isWeekly?false:true;
    var hasFilters=selected.genre.length||selected.hhday.length||selected.hhtype.length;
    function group(k,title,opts){
      return '<fieldset class="obgd-group"><legend>'+title+'</legend><div class="obgd-options">'+opts.map(function(o){
        return '<label class="obgd-option"><input type="checkbox" data-facet="'+k+'" value="'+o[0]+'"'+(selected[k].indexOf(o[0])>=0?' checked':'')+'><span>'+o[1]+'</span></label>';
      }).join('')+'</div></fieldset>';
    }
    var html='<div class="obgd-head"><div><strong>'+(isWeekly?'Find your weekly thing':'Explore more of what you love')+'</strong><small>'+(isWeekly?'Choose a weekday and what sounds fun':'Filter shows by musical style, across this city and beyond')+'</small></div>';
    if(!isWeekly)html+='<a class="obgd-weekly-link" href="'+weeklyLink()+'">Happy Hours + Weekly <span aria-hidden="true">↗</span></a>';
    html+='</div><div class="obgd-controls">';
    if(music)html+=group('genre','Music genres (select any)',genreOptions);
    if(isWeekly)html+=group('hhday','Day of week',dayOptions)+group('hhtype','Type of special or activity',typeOptions);
    html+='</div><div class="obgd-actions"><button type="button" class="obgd-apply">Show matching events</button>';
    if(hasFilters)html+='<button type="button" class="obgd-clear">Clear extra filters</button>';
    html+='<span class="obgd-status" role="status">'+(hasFilters?'Extra filters active':'Mix and match, then apply')+'</span>';
    if(isWeekly)html+='<button type="button" class="obgd-now">Happy hours open now</button>';
    html+='</div><div class="obgd-sync" id="obgdSync"></div>';
    box.innerHTML=html;
    anchor.parentNode.insertBefore(box,anchor);
    box.addEventListener('click',function(ev){
      var t=ev.target.closest('button');if(!t)return;
      if(t.classList.contains('obgd-now')){
        var native=document.getElementById('obgOpen');
        if(native){if(!native.checked)native.click();native.scrollIntoView({behavior:'smooth',block:'center'})}
        else window.location.assign(weeklyLink()+'?when=today');
        return;
      }
      if(t.classList.contains('obgd-clear')){
        ['genre','hhday','hhtype'].forEach(function(k){url.searchParams.delete(k)});
        location.assign(url.pathname+url.search+url.hash);return;
      }
      if(t.classList.contains('obgd-apply')){
        ['genre','hhday','hhtype'].forEach(function(k){
          var picked=Array.prototype.map.call(box.querySelectorAll('input[data-facet="'+k+'"]:checked'),function(i){return i.value});
          if(picked.length)url.searchParams.set(k,picked.join(','));else url.searchParams.delete(k);
        });
        location.assign(url.pathname+url.search+url.hash);
      }
    });
    var syncEl=document.getElementById('obgSyncMeta'),target=document.getElementById('obgdSync');
    if(syncEl&&target){try{
      var meta=JSON.parse(syncEl.textContent);
      if(meta&&meta.synced_at){
        var stamp=new Date(meta.synced_at),ago=(Date.now()-stamp.getTime())/3600000;
        target.textContent='Event feed last synced '+new Intl.DateTimeFormat('en-US',{month:'short',day:'numeric',hour:'numeric',minute:'2-digit',timeZone:window.OB_GUIDE_TZ||'America/Los_Angeles'}).format(stamp)+(ago>48?' · Updates may be delayed':'');
      }
    }catch(_e){}}
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){setTimeout(build,50)});
  else setTimeout(build,50);
})();